var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Center, useRecipe } from "@chakra-ui/react";
import { getColor, getCompanyInitials } from "@/components/utils";
export var CompanyAvatar = function (_a) {
    var companyName = _a.companyName;
    var recipe = useRecipe({ key: "CompanyAvatar" });
    var styles = recipe();
    var color = getColor(companyName);
    var avatarBg = {
        bg: "".concat(color, ".500"),
    };
    var initials = getCompanyInitials(companyName);
    return (_jsx(Center, __assign({ css: __assign(__assign({}, styles), avatarBg), "aria-hidden": "true" }, { children: initials })));
};
